import React from 'react';
import { NewNewsFormUpdate } from 'src/features/user/expert/new-news/NewNewsContainer';

export const EditNews: React.FC = () => {
  const onSuccess = () => {};
  return <NewNewsFormUpdate onSuccess={onSuccess} />;
};
